// eslint-disable-next-line import/prefer-default-export
export var CARD_SECTION_IMAGE_RESOLUTIONS = {
    small: 480,
    medium: 1024,
    large: 1160,
    xlarge: 1520,
    xlargest: 2560
};
